// extracted by mini-css-extract-plugin
module.exports = {"markdown":"content_markdown__g0_4q"};